module.exports = __webpack_public_path__ + "img/full6-min.265a8f38.png";